export const options = [
  { value: 'Poor', label: 'Poor (below 580)' },
  { value: 'Average', label: 'Fair/Average (580-679)' },
  { value: 'Good', label: 'Good (680-719)' },
  { value: 'Excellent', label: 'Excellent (720+)' },
]
